import { createAction, props } from '@ngrx/store';
import { FailedEmails } from './failed-emails.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records failed emails'
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records failed emails success', 
    props<{ listData: FailedEmails[], total: number }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records failed emails failure', 
    props<{ error: string }>()
);

// Update Data
export const updateRecord = createAction(
    '[Data] Update record failed email category',
    props<{ updatedData: any }>()
);
export const updateRecordSuccess = createAction(
    '[Data] Update record failed email category success'
);
export const updateRecordFailure = createAction(
    '[Data] Update record failed email category failure',
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state failed emails',
);